import React from 'react';
import { IconEyeClosed } from '../../assets/SvgSprite';
import * as styles from './LinkDisclaimer.module.scss';
import { getDevicePlatform } from '../../lib/platform';

const LinkDisclaimerContent = ({
  url,
  onLinkClick,
  onCloseClick,
  isInstagram = false,
  showExternalBrowserInstructions = false,
  className,
}) => {
  const { isDesktop } = getDevicePlatform();

  const withExternalBrowserInstructions =
    isInstagram && showExternalBrowserInstructions;

  const showInstructions = !isDesktop && withExternalBrowserInstructions;
  const showContinueActions = isDesktop || !withExternalBrowserInstructions;

  return (
    <div className={className}>
      <IconEyeClosed fill="currentColor" width={36} />

      <h4 className={styles.linkCardDisclaimerTitle}>18+ Content Warning</h4>
      <p className={styles.linkCardDisclaimerText}>
        This link may contain graphic or adult content.
      </p>

      {showInstructions && (
        <div className={styles.externalBrowserInstructionsContainer}>
          <h5 className={styles.externalBrowserInstructionsTitle}>
            To visit this link
          </h5>
          <ol className={styles.externalBrowserInstructions}>
            <li>Tap the three dots on the top right corner</li>
            <li>Select &quot;Open in external browser&quot;</li>
          </ol>
        </div>
      )}

      {showContinueActions && (
        <>
          <a
            className={styles.linkCardDisclaimerButton}
            href={url}
            target="_blank"
            rel="noreferrer"
            onClick={onLinkClick}
          >
            {withExternalBrowserInstructions
              ? 'Tap to open in external browser'
              : 'Continue'}
          </a>

          {isInstagram && (
            <button
              type="button"
              className={styles.linkDisclaimerInstagramCloseButton}
              onClick={onCloseClick}
            >
              Go back and stay on Instagram
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default LinkDisclaimerContent;
